import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=41b18db9&scoped=true&"
import script from "./Delete.js?vue&type=script&lang=js&"
export * from "./Delete.js?vue&type=script&lang=js&"
import style0 from "./Delete.vue?vue&type=style&index=0&id=41b18db9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b18db9",
  null
  
)

export default component.exports